export default class CodeHighlighter extends React.PureComponent

  constructor: (props) ->
    super(props)

  render: ->
    <div className="language-javascript highlighter-rouge">
      <pre className="highlight">
        { @props.children }
      </pre>
    </div>
